// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g1Do5","footer":"styles_footer__30-y9","passCodeTooltip":"styles_passCodeTooltip__1A6Hy"};